import React, { useEffect, useState } from "react";
import "../QuickFilterError/style.css";
import image from "../../img/icons/error-icon-border.svg";

const QuickFilterError = (props) => {
  const {errorList} = props;

  return ( 
    <div className="quickfilter-error">
      <div className="quickfilter-error-wrapper">
        <img className="quickfilter-error-icn" src={image}/>
        <div className="quickfilter-error-content">
          <div className="quickfilter-error-title">Error</div>
            <ul className="quickfilter-error-elements">
            {errorList.map((error, index) => (
              <li key={index} dangerouslySetInnerHTML={{ __html: error }}></li>
              ))}
            </ul>
          </div>
      </div>
    </div>
  )};

export default QuickFilterError;
